import { render, staticRenderFns } from "./SynonymsSettings.vue?vue&type=template&id=337658ae&scoped=true&"
import script from "./SynonymsSettings.vue?vue&type=script&lang=js&"
export * from "./SynonymsSettings.vue?vue&type=script&lang=js&"
import style0 from "./SynonymsSettings.vue?vue&type=style&index=0&id=337658ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337658ae",
  null
  
)

export default component.exports